import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Dashboard.scss';
import { AppIconGg } from '../../img'; //AppGraph,
import SlidingPanel from 'react-sliding-side-panel';



class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ti: '',
      openCloseWidget: false,
    };
  }

  // componentDidMount = () => {
  //   document.getElementById('page_name').innerHTML = 'Dashboard';
  //   document.getElementById('noti_Name').innerHTML = '';
  //   document.getElementById('noti_page_name').innerHTML = '';
  // }


  openCloseWidgetPanel = () => {
    this.state.openCloseWidget = !this.state.openCloseWidget; 
    this.setState(this.state);
  }


  render() {
    return (
      <div className="wdgt-dashborad-content">
        <h1 className="row">
          <div className="col-xs-12">
            <h1>Dasboard</h1>
          </div>
        </h1>
        <div>
          <div className="slidingpanel-defaultnoti">
            <SlidingPanel
              type={'right'}
              isOpen={this.state.openCloseWidget}
              size={75}
              backdropClicked={this.openCloseWidgetPanel}>
              <div className="rightbar-title rightbar-dshbrd-title">
                <div className="rightbar-ttl-part">
                  <img src={AppIconGg} alt="icon" />
                  <h4>Google Reviews</h4>
                </div>
                <div className="rightbar-progress-part">
                  <div className="rightbar-progress-block">
                    <div className="rightbar-progress-top">
                      <span className="progress-top-left">Progress (100/ 5000)</span>
                      <span className="progress-top-right">100%</span>
                    </div>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: '60%', borderRadius: '12px' }} role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                  <div className="upplan-block">

                  </div>
                </div>
                <div className="rightbar-close">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17.181" height="17.09" viewBox="0 0 17.181 17.09">
                    <path id="Path_232" data-name="Path 232" d="M295.416,385.5l6.292-6.292a1,1,0,0,0-1.414-1.415L294,384.089l-6.292-6.292a1,1,0,1,0-1.415,1.415l6.293,6.292-6.293,6.292a1,1,0,0,0,1.415,1.415L294,386.92l6.293,6.292a1,1,0,0,0,1.414-1.415Zm0,0" transform="translate(-285.41 -376.914)" fill="#8392a5" stroke="#8392a5" stroke-width="1" />
                  </svg>
                </div>
              </div>
              <div className="app-dshbrd-list">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="wdgt-thread-box">
                      <div className="wdgt-inblock wdgt-thread-name">
                        <h5 className="noti-type-name">Review Wall -1 </h5>
                      </div>
                      <div className="wdgt-inblock wdgt-thread-design">
                        <div className="wdgt-code-script">
                          <pre>
                            &lt;!-- BEGIN --&gt;
                            <br />
                            &lt;script src="https://apps.demot.com/p/platform.js" defer&gt; &lt;/script&gt; <br />
                            &lt;div className="demot-app-e3b8a974-26b9-4bb3-ac1b-c9faec48002e"&gt;&lt;/div&gt;
                            <br />
                            &lt;!-- END --&gt;
                          </pre>
                        </div>
                        <div className="copy-script-upbg">
                          <div className="copy-script-content">
                            <a href="#" className="nf-btn nf-btn-default">
                              <svg id="copy" xmlns="http://www.w3.org/2000/svg" width="11.225" height="12.177" viewBox="0 0 11.225 12.177">
                                <path id="Path_420" data-name="Path 420" d="M4.165,113.57a2.026,2.026,0,0,1-2.023-2.023v-4.879H1.309A1.31,1.31,0,0,0,0,107.977V114.4a1.31,1.31,0,0,0,1.309,1.309h5.95A1.31,1.31,0,0,0,8.568,114.4v-.833Zm0,0" transform="translate(0 -103.535)" fill="#fff" />
                                <path id="Path_421" data-name="Path 421" d="M135.616,1.309A1.309,1.309,0,0,0,134.307,0h-5A1.309,1.309,0,0,0,128,1.309v5.95a1.309,1.309,0,0,0,1.309,1.309h5a1.309,1.309,0,0,0,1.309-1.309Zm0,0" transform="translate(-124.391 0)" fill="#fff" />
                              </svg>
                              <span>Copy code</span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="wdgt-inblock wdgt-thread-rightgroup">
                        <div className="">
                          <label className="switch">
                            <input type="checkbox" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                        <div className="">

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SlidingPanel>
          </div>
        </div>
      </div>
    );
  }

}

const mapStateToProps = state => ({
  profile: state.getIn(['auth', 'profile']),
  loading: state.getIn(['loading', 'state'])
});


const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Dashboard);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js